'use client';

import { ButtonProps } from './interfaces';

import { StyledSchoolCodeSearchButton, TextWrapper } from './styles';

interface SchoolCodeSearchButtonProps extends ButtonProps {
  hasError?: boolean;
}

// Button that are used in Code Search component in SchoolOnboarding
export const SchoolCodeSearchButton = ({
  label,
  onClick,
  disabled = false,
  hasError = false,
  icon,
  type = 'button',
}: SchoolCodeSearchButtonProps) => {
  return (
    <StyledSchoolCodeSearchButton
      onClick={onClick}
      $disabled={disabled}
      $variant="primary"
      $hasError={hasError}
      disabled={disabled}
      type={type}>
      {icon}
      <TextWrapper>{label}</TextWrapper>
    </StyledSchoolCodeSearchButton>
  );
};
